import { tap, catchError } from 'rxjs/operators';
import Base from 'src/app/Models/Base/base';
import { ListTwoFactorByUserResult } from 'src/app/Models/TwoFactor/list-twoFactorByUser-result';
import { SetTwoFactorResult } from 'src/app/Models/TwoFactor/set-twoFactor-result';
import { ListTwoFactorTypesResult } from 'src/app/Models/TwoFactor/two-factor-result';
import { AppStateService } from '../AppState/app-state.service';
import { ConstService } from '../Const/const.service';
import { of, throwError } from 'rxjs';
import Rutas from 'src/app/Models/Base/rutas';
import { HttpParams } from '@angular/common/http';
export class TwoFactorService {
  constructor(private appStateService: AppStateService) {}

  DisableTwoFactor(code: string) {
    this.appStateService.loading = true;
    let url = `${ConstService.URLApi}/TwoFactor/DisableTwoFactor?code=${code}`;
    return this.appStateService.http.get<Base>(url).pipe(
      tap(({success, message}) => {
        this.appStateService.loading = !true;
        if (success) {
          this.appStateService.showMiniMessage(
            'Método de autenticación desactivado con éxito',
            'success'
          );
          window.location.reload();
        } else {
          throw(message)
        }
      }),
      catchError((err) => {
        this.appStateService.loading = !true;
        this.appStateService.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  ListTwoFactorByUser() {
    this.appStateService.loading = true;
    let url = `${ConstService.URLApi}/TwoFactor/ListTwoFactorByUser`;
    return this.appStateService.http.get<ListTwoFactorByUserResult>(url).pipe(
      tap((res) => {
        this.appStateService.loading = false;
        if (res.success) {
          this.appStateService.ListTwoFactorByUserResult = res;
        } else {
          throw(res.message);
        }
      }),
      catchError((err) => {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  setTwoFactor(code: string, phoneNumber?: string) {
    this.appStateService.loading = true;
    let params = new HttpParams().set('code', code);
    if(!!phoneNumber && !phoneNumber.length){
      phoneNumber = phoneNumber.replace('+', '');
      params = params.append('phoneNumber', phoneNumber)
    }
    let url = `${ConstService.URLApi}/TwoFactor/SetTwoFactor`;
    return this.appStateService.http.get<SetTwoFactorResult>(url, { params })
    .pipe(
      tap((res) => {
         
        this.appStateService.loading = false;
        if (res.success) {
          this.appStateService.SetTwoFactorResult = res;
        } else {
          throw new Error(res.message);
        }
      }),
      catchError((err) => {
        this.appStateService.loading = false;
        return of({ success: false, message: err.message || 'Error interno' });
      })
    );
  }

  ListTwoFactorTypes() {
    this.appStateService.loading = true;
    let url = `${ConstService.URLApi}/TwoFactor/ListTwoFactorTypes`;
    this.appStateService.http.get<ListTwoFactorTypesResult>(url).subscribe(
      (res) => {
        if (res.success) {
          this.appStateService.loading = false;
          this.appStateService.ListTwoFactorTypesResult = res;
          this.appStateService.router.navigateByUrl(Rutas.DOUBLE_FACTOR);
        } else {
          this.appStateService.loading = false;
          this.appStateService.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appStateService.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  RemoveAllTwoFactor(accountID: string): void {
    this.appStateService.loading = true;
    var url: string = `${ConstService.URLApi}/TwoFactor/RemoveAllTwoFactor`;
    var body: any = new Object();
    body = {
      accountID: accountID,
    };
    this.appStateService.http.post<Base>(url, body).subscribe((res: any) => {
      if (res.success) {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(res.message, 'error');
      }
    });
  }
}
